import React, { useEffect, useState } from 'react';
import { Container } from '@components/atoms/Container';
import { RoundIcon, RoundIconVariants } from '@components/atoms/RoundIcon';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@components/atoms/Typography';
import { useTranslation } from 'react-i18next';
import { useTermsAndConditions } from '@services/useTermsAndConditions';
import { Space } from '@components/atoms/Space';
import { useNotifications } from '@hooks/useNotifications';
import styles from './TermsAndConditions.module.css';

export const TermsAndConditions: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { showDefaultNotification } = useNotifications();
    const translations = {
        title: t('terms-and-conditions.title'),
    };

    const { request: requestTermsAndConditions, error, lastResponseTime } = useTermsAndConditions();
    const [terms, setTerms] = useState('');

    useEffect(() => {
        requestTermsAndConditions().then((data) => {
            if (data) {
                setTerms(data.value);
            }
        });
    }, []);

    useEffect(() => {
        if (lastResponseTime) {
            if (error) {
                showDefaultNotification({ type: 'error', message: error });
            }
        }
    }, [lastResponseTime]);

    return (
        <Container>
            <div className={styles.header}>
                <RoundIcon
                    classes={styles.roundIcon}
                    icon="fa-thin fa-arrow-left"
                    variant={RoundIconVariants.variant1}
                    onClick={() => navigate(-1)}
                />

                <Typography fontSize="24" fontWeight="800" classes={styles.title}>
                    {translations.title}
                </Typography>
            </div>

            <Space spaceBreakpoints={{ xs: { space: 15 } }} />
            <div className="d-flex position-relative flex-column gap-3">
                <>{terms && <div className={styles.termsText} dangerouslySetInnerHTML={{ __html: terms }} />}</>
            </div>
        </Container>
    );
};
